<article
  class="way-purchase-selection-card"
  [class.way-purchase-selection-card--canceled]="card.isCanceled"
  [class.way-purchase-selection-card--unavailable]="card.isUnavailable"
>
  <div class="way-purchase-selection-card__header">
    <h4 class="way-purchase-selection-card__title">{{ card.packageName }}</h4>
    <span *ngIf="card.showInShopChip" class="way-purchase-selection-card__chip">In-shop</span>
    <span *ngIf="card.isCanceled" class="way-purchase-selection-card__status-badge">Canceled</span>
    <span *ngIf="card.isUnavailable" class="way-purchase-selection-card__status-badge">Unredeemable</span>
  </div>

  <div class="way-purchase-selection-card__grid">
    <div class="way-purchase-selection-card__field" *ngIf="card.showCustomerName">
      <span class="way-purchase-selection-card__label">Customer name</span>
      <span class="way-purchase-selection-card__value">{{ card.customerName }}</span>
    </div>
    <div class="way-purchase-selection-card__field" *ngIf="card.showCustomerEmail">
      <span class="way-purchase-selection-card__label">Customer email</span>
      <span class="way-purchase-selection-card__value">{{ card.customerEmail }}</span>
    </div>
    <div class="way-purchase-selection-card__field" *ngIf="card.showCustomerPhone">
      <span class="way-purchase-selection-card__label">Customer phone</span>
      <span class="way-purchase-selection-card__value">{{ card.customerPhone }}</span>
    </div>
    <div class="way-purchase-selection-card__field" *ngIf="card.showLicensePlate">
      <span class="way-purchase-selection-card__label">License plate</span>
      <span class="way-purchase-selection-card__value">{{ card.licensePlateDisplay }}</span>
    </div>
    <div class="way-purchase-selection-card__field">
      <span class="way-purchase-selection-card__label">Wash type</span>
      <span class="way-purchase-selection-card__value">{{ card.washTypeLabel }}</span>
    </div>
    <div class="way-purchase-selection-card__field">
      <span class="way-purchase-selection-card__label">Washes available</span>
      <span class="way-purchase-selection-card__value">{{ card.washesAvailableDisplay }}</span>
    </div>
    <div class="way-purchase-selection-card__field">
      <span class="way-purchase-selection-card__label">Price paid</span>
      <span class="way-purchase-selection-card__value">{{ card.priceDisplay }}</span>
    </div>
    <div class="way-purchase-selection-card__field">
      <span class="way-purchase-selection-card__label">Purchased</span>
      <span class="way-purchase-selection-card__value">{{ card.purchasedDisplay }}</span>
    </div>
  </div>

  <div
    class="way-purchase-selection-card__plate"
    *ngIf="card.showPlateInput"
    [class.way-purchase-layout__plate-field--required]="true"
  >
    <label class="way-purchase-selection-card__label" [attr.for]="plateInputId()">
      License plate
    </label>
    <input
      matInput
      type="text"
      class="way-purchase-layout__plate-input"
      [id]="plateInputId()"
      [ngModel]="cardPlateInputs[card.id] ?? ''"
      (ngModelChange)="onCardPlateInput($event)"
      [disabled]="plateInputDisabled"
      [class.p-invalid]="!!plateInputError()"
      autocomplete="off"
      autocapitalize="characters"
      spellcheck="false"
      [attr.aria-invalid]="!!plateInputError()"
      [attr.aria-describedby]="plateInputError() ? plateInputErrorId() : null"
    />
    <small
      *ngIf="plateInputError()"
      class="p-error"
      [id]="plateInputErrorId()"
      role="alert"
    >
      {{ plateInputError() }}
    </small>
  </div>

  <p
    *ngIf="card.isUnavailable && card.unavailableReason"
    class="way-purchase-selection-card__unavailable-reason"
  >
    {{ card.unavailableReason }}
  </p>

  <small
    *ngIf="cardActionError()"
    class="p-error way-purchase-selection-card__action-error"
    role="alert"
  >
    {{ cardActionError() }}
  </small>

  <div class="way-purchase-selection-card__actions" *ngIf="showActions && !card.isUnavailable">
    <button
      type="button"
      class="btn btn-primary btn-small way-purchase-selection-card__action"
      [disabled]="isUseDisabled()"
      (click)="onUse()"
    >
      <span *ngIf="!isCardBusy">Use this one</span>
      <span *ngIf="isCardBusy">Working...</span>
    </button>
    <button
      type="button"
      *ngIf="card.showInShopChip"
      class="btn btn-secondary btn-small way-purchase-selection-card__action way-purchase-selection-card__action--cancel"
      [disabled]="!card.canCancel || isBusy"
      (click)="onCancel()"
    >
      Cancel this one
    </button>
  </div>
</article>
